import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "IsYourCompanyModal" */ /* webpackPrefetch: true */
      './CheckDataModal.component'
    ),
);
